export default __webpack_public_path__ + "static/media/icon-robot-unselect.13efbc0b.webp";